import React from 'react';
import {Edit, SimpleForm} from 'react-admin';

import {CustomToolbar, Grid} from '../../components'
import CongBoDiemFields from './CongBoDiemFields'

export const CongBoDiemEdit = props => (
    <Edit {...props}>
        <SimpleForm toolbar={<CustomToolbar/>}>
            <Grid container spacing={8}>
                <CongBoDiemFields/>
            </Grid>
        </SimpleForm>
    </Edit>
);

export default CongBoDiemEdit
